import { useMemo } from 'react';
import { Store } from '../codegen/graphql';
import {
    getHighestCostPrice,
    getHighestCashbuildCostPrice,
    getHighestPnlCostPrice,
} from '../helpers/priceCalculation';

export function useEffectiveCostPrices({
    applicableTo,
    selectedStoreIds,
    stores,
    store,
    fallbackCostPrice,
}: {
    applicableTo: string;
    selectedStoreIds: string[];
    stores: Store[];
    store: Store | null;
    fallbackCostPrice: number | null;
}) {
    const effectiveStores = useMemo(() => {
        if (applicableTo === 'store') {
            return store ? [store] : [];
        }
        return stores.filter(s => selectedStoreIds.includes(s.id));
    }, [applicableTo, selectedStoreIds, stores, store]);

    const highestCostPrice = useMemo(
        () =>
            effectiveStores.length > 0
                ? getHighestCostPrice(effectiveStores)
                : fallbackCostPrice,
        [effectiveStores, fallbackCostPrice],
    );

    const cashbuildCostPrice = useMemo(
        () =>
            effectiveStores.length > 0
                ? getHighestCashbuildCostPrice(effectiveStores)
                : fallbackCostPrice,
        [effectiveStores, fallbackCostPrice],
    );

    const pnlCostPrice = useMemo(
        () =>
            effectiveStores.length > 0
                ? getHighestPnlCostPrice(effectiveStores)
                : fallbackCostPrice,
        [effectiveStores, fallbackCostPrice],
    );

    return {
        effectiveStores,
        highestCostPrice,
        cashbuildCostPrice,
        pnlCostPrice,
    };
}
